"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIAL_PARCEL_VALUE = exports.INITIAL_ITEMS_WITHOUT_CHILDREN = exports.INITIAL_ITEMS = exports.INITIAL_DROPDOWN_VALUES = void 0;
var INITIAL_ITEMS = [{
  id: "00cb5c36-eb57-462e-ae43-d40417a4841b",
  title: "مرکزی - اراک",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  checked: true,
  children: [{
    id: '123456789',
    title: 'سبزوار',
    checked: false
  }, {
    id: '12345789',
    title: 'مشهد',
    checked: false
  }, {
    id: '123456289',
    title: 'مجیدیه',
    checked: false
  }, {
    id: '12556789',
    title: 'جردن',
    checked: false
  }]
}, {
  id: "585bd5fd-b16c-416d-85f3-9589d8a7eb8d",
  title: "مرکزی - آشتیان",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  checked: false,
  children: [{
    id: '12347856789',
    title: 'محمد آباد',
    checked: false
  }, {
    id: '1283456789',
    title: 'احمد آباد',
    checked: false
  }, {
    id: '1234568789',
    title: 'ظفر',
    checked: false
  }, {
    id: '7123456789',
    title: 'باغ',
    checked: false
  }]
}, {
  id: "7202f785-83cb-4f6a-aecc-ddd24832305d",
  title: "البرز - کرج",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  checked: false,
  children: [{
    id: '12345669789',
    title: 'کرج',
    checked: false
  }, {
    id: '12347956789',
    title: 'اشتهارد',
    checked: false
  }, {
    id: '123458556789',
    title: 'فردیس',
    checked: true
  }, {
    id: '12345868746789',
    title: 'طالقان',
    checked: false
  }]
}, {
  id: "d9a308d7-adfb-45f8-aa23-cf457ca7cd07",
  title: "رشت - رشت",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  checked: false,
  children: [{
    id: '12345886789',
    title: 'مازندران',
    checked: false
  }, {
    id: '12345674488789',
    title: 'ساری',
    checked: false
  }, {
    id: '123456855789',
    title: 'چالوس',
    checked: false
  }, {
    id: '1234569582789',
    title: 'رامسر',
    checked: false
  }]
}, {
  id: "293f402d-f463-4bdd-a2e0-f92259fa4c97",
  title: "بوشهر - ساوه",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  checked: false,
  children: []
}];
exports.INITIAL_ITEMS = INITIAL_ITEMS;
var INITIAL_ITEMS_WITHOUT_CHILDREN = [{
  id: "00cb5c36-eb57-462e-ae43-d40417a4841b",
  title: "مرکزی - اراک",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  checked: false,
  value: '',
  items: [],
  valueUnit: 'IRT',
  children: []
}, {
  id: "585bd5fd-b16c-416d-85f3-9589d8a7eb8d",
  title: "مرکزی - آشتیان",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  checked: false,
  value: '',
  items: [],
  valueUnit: 'IRT',
  children: []
}, {
  id: "7202f785-83cb-4f6a-aecc-ddd24832305d",
  title: "البرز - کرج",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  checked: false,
  value: '',
  items: [],
  valueUnit: 'IRT',
  children: []
}, {
  id: "d9a308d7-adfb-45f8-aa23-cf457ca7cd07",
  title: "رشت - رشت",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  checked: false,
  value: '',
  items: [],
  valueUnit: 'IRT',
  children: []
}, {
  id: "293f402d-f463-4bdd-a2e0-f92259fa4c97",
  title: "بوشهر - ساوه",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  checked: false,
  value: '',
  items: [],
  valueUnit: 'IRT',
  children: []
}];
exports.INITIAL_ITEMS_WITHOUT_CHILDREN = INITIAL_ITEMS_WITHOUT_CHILDREN;
var INITIAL_PARCEL_VALUE = [{
  id: 2,
  name: "تومان",
  unit: "IRT"
}, {
  id: 1,
  name: "ریال",
  unit: "IRR"
}];
exports.INITIAL_PARCEL_VALUE = INITIAL_PARCEL_VALUE;
var INITIAL_DROPDOWN_VALUES = [{
  id: "00cb5c36-eb57-462e-ae43-d40417a4841b",
  title: "مرکزی - اراک",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  "default": true
}, {
  id: "585bd5fd-b16c-416d-85f3-9589d8a7eb8d",
  title: "مرکزی - آشتیان",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  "default": true
}, {
  id: "7202f785-83cb-4f6a-aecc-ddd24832305d",
  title: "مرکزی - تفرش",
  provinceId: "cb865f5f-7358-4452-b329-b19c56e4e201",
  "default": true
}];
exports.INITIAL_DROPDOWN_VALUES = INITIAL_DROPDOWN_VALUES;